<template>
  <b-row>
    <b-col>
      <fieldset class="font-weight-bold text-muted small">
        {{ descricao }}
      </fieldset>
    </b-col>
    <b-col cols="12">
      <hr
        class="mx-0 mt-0 mb-2"
        style="border-top: 1px solid #a3a4a66b !important;"
      >
    </b-col>

    <!-- Descrição -->
    <b-form-group
      label="Descrição"
      class="col-9"
    >
      <validation-provider
        #default="{ errors }"
        rules="required"
        name="Descrição"
      >
        <b-input
          v-model="form.descricao"
          placeholder="Insira uma descrição"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Template -->
    <b-form-group
      label="Template"
      class="col-3"
    >
      <validation-provider
        #default="{ errors }"
        rules="required"
        name="Template"
      >
        <b-form-select
          v-model="form.templateVinculo"
          :options="templateOptions"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Tipo de proposta -->
    <b-form-group
      label="Tipo de proposta"
      class="col-4"
    >
      <validation-provider
        #default="{ errors }"
        rules="required"
        name="Tipo proposta"
      >
        <b-select
          v-model="form.tipoProposta"
          :options="propostaOptions"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Matriz / Filial -->
    <b-col cols="2">
      <b-form-group label="Matriz/Filial">
        <b-select
          v-model="form.matriz"
          :options="matrizOpcoes"
          @change="mudarOpcoesTipo"
        />
      </b-form-group>
    </b-col>

    <!-- Nível -->
    <b-col cols="3">
      <b-form-group label="Nível">
        <validation-provider
          #default="{ errors }"
          :rules="form.matriz ? 'required' : ''"
          name="Nível"
        >
          <b-select
            v-model="form.nivel"
            :disabled="!form.matriz"
            :options="nivelOpcoes"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Tipos de Tributação -->
    <b-col cols="3">
      <b-form-group label="">
        <validation-provider
          #default="{ errors }"
          :rules="form.matriz ? 'required' : ''"
          name="Tipos de Tributação"
        >
          <tributacao-select
            v-model="tipoTributacaoSelecionada"
            :require="form.matriz"
            :disabled="form.matriz !== undefined && form.matriz === false"
            @input="onTipoTributacaoChange"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<style src="@core/scss/vue/libs/quill.scss" lang="scss"></style>
<style lang="scss">
.ql-editor {
  height: 800px;
  overflow: auto;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}
</style>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'

import TributacaoSelect from '@/shared/components/tipo-tributacao-select/TipoTributacaoSelect.vue'
import apiTipoTributacao from '@/app-modulo/comercial/tipo-tributacao/shared/services/api'

export default {
  name: 'CadastroTemplate',
  components: {
    ValidationProvider,
    TributacaoSelect,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
    descricao: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
      form: {
        templateVinculo: 'contrato',
        // enum utilizado pelo back-end (ETipoTemplate)
        tipoTemplate: null,
        // id da TipoTributacao vinculada
        tipoTributacaoId: null,
      },
      // objeto selecionado no componente de tipos de tributação
      tipoTributacaoSelecionada: null,
      templateOptions: [
        { value: 'contrato', text: 'Contrato' },
      ],
      propostaOptions: [
        { value: 'constituicao', text: 'Proposta honorários empresas em constituição' },
        { value: 'transferencia', text: 'Proposta honorários empresas em transferência' },
        { value: 'constituicaotransferencia', text: 'Proposta honorários empresas em constituição & transferência' },
      ],
      nivelOpcoes: [
        { value: 'nivel1', text: 'Nível I - Básico' },
        { value: 'nivel2', text: 'Nível II - Essencial' },
        { value: 'nivel3', text: 'Nível III - Avançado' },
      ],
      // sem opção invisível
      matrizOpcoes: [
        { value: true, text: 'Matriz' },
        { value: false, text: 'Filial' },
      ],
    }
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.form = value
        this.syncTipoTributacaoFromForm()
      }
    },
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    this.form = this.value
    this.syncTipoTributacaoFromForm()
  },
  methods: {
    mudarOpcoesTipo() {
      this.form.nivel = null
      this.onTipoTributacaoChange(null)
    },
    // quando muda o select de tipos de tributação
    onTipoTributacaoChange(value) {
      this.tipoTributacaoSelecionada = value

      if (!this.form) {
        this.form = {}
      }

      // salva o ID da tributação que será enviado para o back-end
      this.form.tipoTributacaoId = value && value.id ? value.id : null

      // mantém o campo TipoTemplate (enum) compatível com a tributação escolhida
      if (!value) {
        this.form.tipoTemplate = null
        return
      }

      if (value.recursosHumanos) {
        this.form.tipoTemplate = 'RecursosHumanos'
      } else if (value.mei) {
        this.form.tipoTemplate = 'Mei'
      } else if (value.domestica) {
        this.form.tipoTemplate = 'Domestica'
      } else if (value.consultoria) {
        this.form.tipoTemplate = 'Consultoria'
      } else if (value.simplesNacional) {
        this.form.tipoTemplate = 'SimplesNacional'
      } else {
        this.form.tipoTemplate = 'Nenhum'
      }
    },
    // ao carregar tela (especialmente em edição) busca o objeto pelo ID
    syncTipoTributacaoFromForm() {
      const tipoId = this.form && this.form.tipoTributacaoId

      if (!tipoId || (typeof tipoId !== 'number' && Number.isNaN(Number(tipoId)))) {
        this.tipoTributacaoSelecionada = null
        return
      }

      apiTipoTributacao.getTipoTributacao(tipoId)
        .then(resp => {
          this.tipoTributacaoSelecionada = resp.data
        })
        .catch(() => {
          this.tipoTributacaoSelecionada = null
        })
    },
  },
}
</script>
